import Form from "../form/Form";
import { useParams } from "react-router";
import { MainContainerForm, MainPadding } from "../../../styles/Main.styles";

export default function Creation() {
  const { idSubDealer } = useParams();

  return (
    <MainPadding>
      <MainContainerForm>
        <Form idSubDealer={idSubDealer} />
      </MainContainerForm>
    </MainPadding>
  );
}
